<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-51"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div class="flex flex-col p-[20px] gap-[22px] bg-[#FCFCFC]">
            <div class="flex flex-col items-center">
              <ResourcesIcon class="w-[50px] h-[50px] text-[#9B237B]" />
              <span class="PC_Body1-SB !text-[#1F1D1F]">
                แก้ไขคำร้องขอทรัพยากร
              </span>
            </div>
            <div
              class="flex flex-col gap-[14px] px-[10px] py-[14px] rounded-[6px] border-[1px] border-solid border-[#b7b2b5] bg-[#fff]"
            >
              <div class="flex flex-col gap-[8px]">
                <div class="flex items-start gap-[6px]">
                  <div
                    class="min-w-[72px] min-h-[72px] w-[72px] h-[72px] border-[1px] border-solid border-[#F2E7F9]"
                  >
                    <img
                      :src="item.image_path || 'https://placehold.co/48x48/png'"
                      alt=""
                    />
                  </div>
                  <div>
                    <div class="PC_Body1-R !text-[#1F1D1F]">{{ item.name }}</div>
                    <div class="cardLabel">
                      {{ item.unit_name }}
                    </div>
                    <div class="cardLabel">
                      {{ item.category_name }}
                    </div>
                  </div>
                </div>
                <div class="w-full h-[1px] bg-[#DFDCDD]"></div>
                <div class="flex gap-[4px] PC_Body2-R text-[#1F1D1F]">
                  <span> จำนวนที่ต้องการปัจจุบัน </span>
                  <span>:</span>
                  <span v-if="item.request == -1"> ไม่จำกัด </span>
                  <span v-else>
                    {{ $numberAndComma(item.request) || "0" }}
                  </span>
                </div>
                <div class="flex gap-[4px] PC_Body2-R text-[#1F1D1F]">
                  <span> ยอดที่ได้รับ </span>
                  <span>:</span>
                  <span>
                    {{ $numberAndComma(item.quantity) || "0" }}
                  </span>
                </div>
              </div>
              <div class="flex flex-col gap-[10px]">
                <div class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]">
                  <span class="title"> แก้ไขจำนวนที่ต้องการใหม่ </span>
                </div>
                <Radio
                  :id="'resources_choice0'"
                  v-model="form.choice"
                  :name="'resources_choice0'"
                  :value="0"
                  :label="'ระบุจำนวนที่ต้องการ'"
                  :quantitySelector="true"
                  :minValue="item.quantity"
                  :fieldValue="form.request"
                  @update:fieldValue="
                    (val) => {
                      form.request = val;
                    }
                  "
                />
                <Radio
                  :id="'resources_choice1'"
                  v-model="form.choice"
                  :name="'resources_choice1'"
                  :value="1"
                  :label="'ไม่ระบุจำนวน'"
                  :disabled="item.quantity > 0"
                />
              </div>
            </div>
            <div class="flex items-center justify-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--save'"
                :disabled="
                  (form.choice == 0 && form.request == item.request) ||
                  form.request == 0
                "
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";

const { $validateMsg } = useGlobals();
const productStore = useProductStore();
const input = {
  product_id: "",
  choice: 0,
  request: "0",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const item = ref({});
const modalIsOpened = ref(false);

const emit = defineEmits(["status", "update"]);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  item.value = data;
  if (item.value.request == -1) {
    form.value.request = 0;
    form.value.choice = 1;
  } else {
    form.value.choice = 0;
    form.value.request = item.value.request;
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = async () => {
  const body = {
    id: item.value.id,
    status: 1,
    request: form.value.choice != 1 ? form.value.request : -1,
  };
  await productStore
    .updateProductRequest(body)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        emit("update");
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
.title {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>